/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Checkbox, FormControlLabel, Alert, Modal, Box } from '@mui/material';
import axios from 'axios'
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux'
import {
  getStyle, setBizID, setStyle, setLogo, getLogo, setBackground, getBackground, setRoles, getBizID,
  setBusinessName, setChangePassword, getChangePassword, setRequestCA, getRequestCA, getBizName, setServices, setConsentAccepted, getConsentAccepted
} from '../../libs/todoSlice'
import Menu from '@mui/material/Menu';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Hidden } from "@material-ui/core";
import LoadingComponent from '../../lib/LoadingComponent';
import { RemoveScrollBar } from 'react-remove-scroll-bar';
import TermAndCondition from './TermAndCondition';
import VerifyDetail from './VerifyDetail';
import SendMail from './SendMail';
import ChangePassword from './ChangePassword';
import SendMailSuccess from './SendMailSuccess';
import TabIndexContent from "react-tabindex-content";
import FadeIn from 'react-fade-in'
import fontColor from '../../lib/fontColor';
import {
  getStepRedux, setStepRedux, getCheckboxRedux, setCheckboxRedux, getLoadingRedux,
  setLoadingRedux, getLoginFeedbackRedux, setLoginFeedbackRedux, getUsernameRedux, setUsernameRedux, getPasswordRedux,
  setPasswordRedux, getShowPasswordRedux, setShowPasswordRedux, getTempCookieRedux, setTempCookieRedux
} from '../../libs/LoginUserSlice';
import ResetPasswordByEmail from '../ResetPasswordByEmail';
import ResetPasswordByOTP from '../ResetPasswordByOTP';
import { getOpenRedux, setOpenRedux } from '../../libs/loginSlice';
import { useState } from 'react';

function Login_User() {
  const dispatch = useDispatch()
  const params = useParams()
  const [cookie, setCookie, removeCookie] = useCookies(['account', 'new_user', 'oauth_callback', 'cookie_consent_accepting'])
  const navigate = useNavigate()
  const style = useSelector(getStyle)
  const logo = useSelector(getLogo)
  const background = useSelector(getBackground)
  const businessName = useSelector(getBizName)
  const business_id = useSelector(getBizID)
  const [consentModal, setConsentModal] = useState(false);
  const [acceptPrivacy, setAcceptPrivacy] = useState(false);
  const [oauthActive, setOauthActive] = useState(false);
  const open = useSelector(getOpenRedux)
  const setOpen = (action) => {
    dispatch(setOpenRedux({
      open: action
    }))
  }
  const [ pageLoading, setPageLoading] = useState(false)
  useEffect(() => {
    let url = new URL(window.location.href)
    const searchParams = url.searchParams;
    const loadingParams = searchParams.get('loading')
    if(loadingParams) {
      setPageLoading(true)
      setTimeout(() => {
        if(pageLoading){
          window.location.reload()          
        }
      }, 1000)
    }
    setAnchorEl(null)
    setStep('guest')
    setCheckbox(false)
    setLoading(false)
    setShowPassword(false)
    setTempCookie({})
    setLoginFeedback('')
    setUsername('')
    setPassword('')
  }, [])

  const [anchorEl, setAnchorEl] = useState(null)

  const step = useSelector(getStepRedux)
  const setStep = (action) => {
    dispatch(setStepRedux({
      step: action
    }))
  }

  const checkbox = useSelector(getCheckboxRedux)
  const setCheckbox = (action) => {
    dispatch(setCheckboxRedux({
      checkbox: action
    }))
  }

  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }

  const loginFeedback = useSelector(getLoginFeedbackRedux)
  const setLoginFeedback = (action) => {
    dispatch(setLoginFeedbackRedux({
      loginFeedback: action
    }))
  }

  const username = useSelector(getUsernameRedux)
  const setUsername = (action) => {
    dispatch(setUsernameRedux({
      username: action
    }))
  }

  const password = useSelector(getPasswordRedux)
  const setPassword = (action) => {
    dispatch(setPasswordRedux({
      password: action
    }))
  }



  useEffect(() => {
    removeCookie('account')
    if (cookie.new_user) {
      dispatch(setRequestCA({
        requested_ca: cookie.new_user.requestCA,
      }))
    }
  }, [])

  const getBusinessName = async (bizid) => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/biz-name?business_id=${bizid}`,
      })
      dispatch(setBusinessName({
        business_name: data.data.businessName
      }))
    } catch ({ response }) {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }
  const consentAccepted = useSelector(getConsentAccepted)
  const login = async () => {
    setLoading(true)
    setLoginFeedback('')
    await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/login-user`,
      data: {
        username: username,
        password: password,
        is_remember: checkbox,
        business_id: business_id,
      }
    }).then(({ data, status }) => {
      setLoginFeedback({
        message: 'เข้าสู่ระบบสำเร็จ',
        color: 'success'
      })
      if (sessionStorage.getItem('token_email') && sessionStorage.getItem('email_id')) {
        activateEmail(data.data.access_token)
      }
      dispatch(setChangePassword({
        change_password: data.data.changed_password,
      }))
      getAccount(data.data.access_token, {
        changed_password: data.data.changed_password,
        consent_accepted: data.data.consent_accepted,
        requestCA: data.data.requested_ca
      },)
      dispatch(setConsentAccepted({
        consent_accepted: data.data.consent_accepted,
      }))
      dispatch(setRequestCA({
        requested_ca: data.data.requested_ca,
      }))
    }, ({ response }) => {
      setLoginFeedback({
        message: 'เข้าสู่ระบบไม่สำเร็จ',
        color: 'error'
      })
    })
    setLoading(false)
  }


  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const tempCookie = useSelector(getTempCookieRedux)
  const setTempCookie = (action) => {
    dispatch(setTempCookieRedux({
      tempCookie: action
    }))
  }

  const showPassword = useSelector(getShowPasswordRedux)
  const setShowPassword = (action) => {
    dispatch(setShowPasswordRedux({
      showPassword: action
    }))
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const searchParams = new URLSearchParams(document.location.search)
  useEffect(() => {
    getPrefixDetail()
    if (searchParams.get('token_email') && searchParams.get('email_id')) {
      sessionStorage.setItem('token_email', searchParams.get('token_email'));
      sessionStorage.setItem('email_id', searchParams.get('email_id'));
      navigate(`/${params.prefix}`)
    }
  }, []);

  const activateEmail = async (access_token) => {
    await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/confirm-email`,
      data: {
        token_email: sessionStorage.getItem('token_email'),
        email_id: sessionStorage.getItem('email_id'),
      }
    }).then(({ data, status }) => {
      sessionStorage.removeItem('token_email');
      sessionStorage.removeItem('email_id');
    }, ({ response }) => {
    })
  }
  useEffect(() => {
    if (business_id) {
      if (localStorage.getItem('account')) {
        if (cookie.new_user) {
          if (localStorage.getItem('account')) {
            if (requestCA || cookie.new_user.requestCA) {
              setStep('popup_consent')
            }
            else if (!cookie.new_user.changed_password) {
              if (step !== 'changed_password') {
                setStep('changed_password')
              }
            }
            else {
              if (localStorage.getItem('policy_accept')){
                navigate(`/${params.prefix}/manage-members`)
              }else{
                setStep('policy')
              }
            }
          }
        }
      } else {
        localStorage.removeItem('account')
      }
    }
  }, [business_id, cookie]);
  useEffect(() => {
    document.body.classList.add('login');
    return () => {
      document.body.classList.remove('login');
    }
  })

  const setCookieCustom = async (key, value, expire) => {
    const cookieName = key;
    const cookieValue = value;
    const expirationDays = expire; // Set the number of days until the cookie expires.

    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);

    const cookieString = `${cookieName}=${cookieValue}; expires=${expirationDate.toUTCString()}; path=/`;

    document.cookie = cookieString;
  }
  
  const getAccount = async (access_token, new_user) => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/user-management`,
      })
      
        await checkCondition()   
        if (!checkbox) {
          const expirationDate = new Date(Date.now() + 3600000);
          localStorage.setItem('account', JSON.stringify(data.data))
          await setCookieCustom('new_user', JSON.stringify({ ...new_user, requestCA: new_user.requestCA }),  Math.ceil((expirationDate - new Date()) / (1000 * 60 * 60 * 24)))
        
        } else {
          const expirationDate = new Date(Date.now() + 5184000000);
          localStorage.setItem('account', JSON.stringify(data.data))
          await setCookieCustom('new_user', JSON.stringify({ ...new_user, requestCA: new_user.requestCA }),  Math.ceil((expirationDate - new Date()) / (1000 * 60 * 60 * 24)))
          await setCookieCustom('remember', JSON.stringify(true),  Math.ceil((expirationDate - new Date()) / (1000 * 60 * 60 * 24)))
        }
        if (new_user.requestCA) {
          setStep('popup_consent')
        }
        else if (new_user.changed_password) {
          if (localStorage.getItem('policy_accept')){
            navigate(`/${params.prefix}/home`)  
          }
          setStep('policy')
        } else if(new_user.changed_password === false){
          setStep('changed_password')
        }
    } catch (error) {
      console.log('error :>> ', error);
    }
   
  }

  const oauthRedirect = async () => {
    setCookie('oauth',
      true, {
      path: '/',
      expires: new Date(Date.now() + 3600000),
      // httpOnly: true
    })
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/oauth/code`,
    }).then(({ data, status }) => {
      setCookie('oauth_callback',
        params.prefix, {
        path: '/',
        expires: new Date(Date.now() + 3600000),
      })
      window.location.href = `${process.env.REACT_APP_ONE_ID}/api/oauth/getcode?client_id=${data.data.clientID}&response_type=code&redirect_uri=${data.data.redirectURL}&scope=title account first_name last_name id_card birth_date email tel pic`
    })
  }


  const getPrefixDetail = async () => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/prefix?prefix=${params.prefix}`,
    }).then(({ data, status }) => {
      if (!data.data) {
        navigate('/notfound')
      } else {
        dispatch(setBizID({
          biz_id: data.data.businessID
        }))
        dispatch(setStyle({
          style: data.data.themes.style
        }))
        dispatch(setServices({
          services: data.data.services
        }))
        if(data.data.settingPassword.length > 0 ){
          setOauthActive(data.data.settingPassword[0].oauthActive);
        }
      }
      getBusinessName(data.data.businessID)
      getLogoApi(data.data.businessID)
      getBackgroundApi(data.data.businessID)
      if(localStorage.getItem('account')){
        getRoles(data.data.businessID)
      }
      dispatch(setBusinessName({
        business_name: data.data.businessName
      }))
    }, ({ response }) => {
      navigate('/notfound')
    })
  }

  const getRoles = async (bizid) => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/roles?business_id=${bizid}`,
    }).then(({ data, status }) => {
      if (!data.data) {
        navigate('/notfound')
      } else {
        dispatch(setRoles({
          roles: data.data
        }))
      }
    }, ({ response }) => {
      const { status } = response
      if (status === 401) {
        localStorage.removeItem('account')
        navigate(`/${params.prefix}`)
      }
      if (status === 403) {
        navigate('/forbidden')
      }
    })
  }

  const checkCondition = async () => {
    if (tempCookie.account) {
      let account = { ...tempCookie.account }
      delete account.account_attribute
      delete account.account_category
      delete account.address_id
      delete account.blockchain_flg
      delete account.created_by
      delete account.hash_id_card_num
      delete account.id_card_type
      delete account.last_update
      delete account.name_on_document_eng
      delete account.name_on_document_th
      delete account.reason
      delete account.register_dt
      delete account.special_title_name_eng
      delete account.special_title_name_th
      delete account.status_cd
      delete account.status_dt
      delete account.thai_email2
      delete account.thai_email3
      delete account.trust_level
      delete account.updated_at
      delete account.updated_by
      delete account.address
      delete account.mobile
      if (!checkbox) {
        localStorage.setItem('account', JSON.stringify(account))
        await new Promise((resolve, reject) => {
          setCookie('new_user',
          { ...tempCookie.new_user, requestCA: requestCA },{
            path: '/',
            expires: new Date(Date.now() + 3600000),
          }, (error) => {
            if (error) {
              reject(error);
            } else {
              resolve();
            }
          });
        });       
        if (localStorage.getItem('account')) {
          return localStorage.getItem('account')
        }
      } else {
        localStorage.setItem('account', JSON.stringify(account))
        await new Promise((resolve, reject) => {
          setCookie('remember',
          true,{
            path: '/',
            expires: new Date(Date.now() + 5184000000),
          }, (error) => {
            if (error) {
              reject(error);
            } else {
              resolve();
            }
          });
        });   

        await new Promise((resolve, reject) => {
          setCookie('new_user',
          { ...tempCookie.new_user, requestCA: requestCA },{
            path: '/',
            expires: new Date(Date.now() + 5184000000),
          }, (error) => {
            if (error) {
              reject(error);
            } else {
              resolve();
            }
          });
        });  
      }
      return !!localStorage.getItem('account')
    }
  }
  const getLogoApi = async (bizid) => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/logo?business_id=${bizid}`,
    }).then(({ data, status }) => {
      dispatch(setLogo({
        logo: data.data
      }))
    }, ({ response }) => {

    })
  }
  const getBackgroundApi = async (bizid) => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/background?business_id=${bizid}`,
    }).then(({ data, status }) => {
      dispatch(setBackground({
        background: data.data
      }))
    }, ({ response }) => {

    })
  }
  const bizID = useSelector(getBizID)
  const changedPass = useSelector(getChangePassword)
  const requestCA = useSelector(getRequestCA)
  const acceptPolicy = async () => {
    try {
      localStorage.setItem('policy_accept', true)
      checkCondition()
      if (requestCA) {
        setStep('popup_consent')
      }
      if(changedPass === false){
        setStep('changed_password')
      }
      navigate(`/${params.prefix}/home`)
    } catch (error) {
      console.log('error :>> ', error);
    }
    
  }

  return (
    !pageLoading ?
      <>
        <RemoveScrollBar />
        {
          {
            "guest": (
              <body
                style={{
                  // background: '#F8F9FA', 
                  height: '100vh',
                }}
              >
                {/* <FadeIn > */}
                <div
                  className='container'
                >
                  <div className="row mt-3 mt-md-5 pe-3 pe-md-0 justify-c">
                    <div className="col-12 col-md-6 text-center text-md-start">
                      <img
                        src={`data:image/png;base64, ${logo}`}
                        alt=""
                        onError={({ target }) => {
                          target.src = '/one-platform.png'
                        }}
                        style={{
                          maxHeight: style.logo_style == 2 ? '80px' : '60px',
                          maxWidth: style.logo_style == 2 ? '120px' : '60px',
                        }}
                      />
                      <span
                        style={{
                          fontWeight: '600',
                          color: '#053075',
                          padding: '10px',
                        }}
                      >{businessName}</span>
                    </div>
                    <div className="col-12 col-md-6 text-center mt-3 mt-md-0 text-md-end">
                      <Button
                        onClick={(event) => {
                          setAnchorEl(event.currentTarget);
                        }}
                        sx={{
                          color: fontColor(style.secondary_color),
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: '9px 24px',
                          gap: '10px',
                          width: '120px',
                          height: '36px',
                          background: style.secondary_color ?? '#053075',
                          borderRadius: '6px',
                        }}
                      >
                        เข้าสู่ระบบ
                      </Button>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    color: '#053075',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: '20px',
                    position: 'absolute',
                    width: '50%',
                    maxWidth: '550px',
                    height: '275px',
                    left: '84px',
                    top: '250px',
                    zIndex: '2'
                  }}
                >
                  <div
                    style={{
                      letterSpacing: '0.02em',
                      wordBreak: 'break-all'
                    }}
                    dangerouslySetInnerHTML={{ __html: style.landing_page_wording }}
                  />
                </div>
                <Hidden xsDown>
                  <div style={{ display: 'flex', justifyContent: 'right' }}>
                    <img
                      src={`data:image/png;base64, ${background}`}
                        onError={({ target }) => {
                          target.src = '/img_login_RA_new.png'
                        }}
                      style={{
                        position: 'absolute',
                        width: '670.75px',
                        height: '650.54px',
                        top: '200px',
                        marginRight: '70px',
                        zIndex: '1'
                      }}
                      alt=''
                    />
                    <img
                      src="/img_login_RA_vector.png"
                      style={{
                        position: 'absolute',
                        top: '270px',
                        zIndex: '0',
                        height: '-webkit-fill-available'
                      }}
                      alt=''
                    />
                  </div>
                </Hidden>
                <Menu
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorEl)}
                  style={{
                    top: '50px',
                  }}
                >
                  <div
                    style={{
                      padding: '10px 20px',
                      width: '308px',
                    }}
                  >
                    <div style={{ padding: '10px', textAlign: 'center' }}>
                      <span
                        style={{
                          fontSize: '16px',
                        }}
                      >
                        <b>เข้าสู่ระบบ</b>
                        <br />
                      <span>{oauthActive ? '' : 'Registration Authority'}</span>
                      </span>
                    </div>
                    {!oauthActive && (
                      <div style={{ textAlign: 'center', margin: '10px' }}>
                        <button
                          style={{ border: 'none', background: 'none' }}
                          onClick={() => {
                            oauthRedirect();
                          }}
                        >
                          <img
                            src="/one-platform.png"
                            style={{
                              width: '36px',
                              height: '100%',
                            }}
                            alt=""
                          />
                        </button>
                      </div>
                    )}
                    {!oauthActive && (
                      <div style={{ textAlign: "center", margin: "10px" }}>
                        <span>หรือ</span>
                      </div>
                    )}
                    <TabIndexContent global={true} allowReadOnly={true}>
                      <div className="flex flex-column gap-2">
                        <div style={{ display: 'flex', }}>
                          <label htmlFor="username" style={{ color: 'black' }}>ชื่อผู้ใช้งาน</label>
                        </div>
                        <OutlinedInput
                          id="username"
                          value={username}
                          placeholder="กรอกชื่อผู้ใช้งาน"
                          sx={{
                            width: '268px',
                            height: '36px',
                            borderRadius: '6px',
                            border: '1px solid #EEEEEE',
                            margin: '10px 0',
                          }}
                          onChange={({ target }) => {
                            setUsername(target.value);
                          }}
                          onKeyUp={(e) => {
                            if (e.key === 'Enter' && username.length > 0 && password.length > 0) {
                              login()
                            }
                          }}
                          inputProps={{
                            maxLength: 100,
                            tabIndex: '0'
                          }}
                        />
                      </div>
                      <div className="flex flex-column gap-2">
                        <div style={{ display: 'flex', }}>
                          <label htmlFor="password" style={{ color: 'black' }}>รหัสผ่าน</label>
                        </div>
                        <OutlinedInput
                          id="password"
                          type={showPassword ? 'text' : 'password'}
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value)
                          }}
                          inputProps={{
                            maxLength: 100,
                            tabIndex: '1'
                          }}
                          placeholder="กรอกรหัสผ่าน"
                          sx={{
                            width: '268px',
                            height: '36px',
                            borderRadius: '6px',
                            border: '1px solid #EEEEEE',
                            margin: '10px 0',
                          }}
                          onKeyUp={(e) => {
                            if (e.key === 'Enter' && username.length > 0 && password.length > 0) {
                              login()
                            }
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => {
                                  setShowPassword(!showPassword)
                                }}
                                edge="end"
                                style={{ color: style.secondary_color ?? '#999999', borderColor: style.secondary_color ?? '' }}
                                tabIndex="2"
                              >
                                {!showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </div>
                    </TabIndexContent>

                    {loginFeedback.message && <FadeIn>
                      <div>
                        <Alert variant="filled" severity={loginFeedback.color} style={{ width: '268px' }}>
                          {loginFeedback.message}
                        </Alert>
                      </div>
                    </FadeIn>}
                    <div className="col-12">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={({ target }) => setAcceptPrivacy(target.checked)}
                          />
                        }
                        label={
                          <>
                            ยอมรับ
                            <span
                              style={{
                                fontSize: '16px',
                                color: 'rgba(25, 118, 210, 1)',
                                marginLeft: '2px'
                              }}
                              onClick={() => {
                                // setConsentModal(true)
                                window.open('https://one.th/privacy-policy', '_blank')
                              }}
                            >
                              นโยบายคุ้มครองข้อมูลส่วนบุคคล
                            </span>
                          </>
                        }
                      />

                      <Modal
                        open={consentModal}
                        onClose={() => {
                          setConsentModal(false)
                        }}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                      >
                        <div className="container">
                          <div className="row">
                            <div className="col">
                              <Box
                                className=""
                                sx={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  bgcolor: 'background.paper',
                                  borderRadius: '16px',
                                  boxShadow: 24,
                                  width: "100%",
                                  maxWidth: "650px",
                                  p: 4,
                                }}>
                                <iframe
                                  title="Privacy Policy"
                                  src='https://one.th/privacy-policy'
                                  width="600"
                                  height="500"
                                >
                                </iframe>
                                <div className="row mt-2">
                                  <div className="col text-end">
                                    <Button
                                      style={{ fontSize: '16px' }}
                                      size='small'
                                      onClick={() => {
                                        setConsentModal(false)
                                      }}>
                                      ปิด
                                    </Button>
                                  </div>
                                </div>
                              </Box>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    <div className="col-12">
                      <FormControlLabel sx={{ color: '#000000' }} control={<Checkbox onChange={({ target }) => setCheckbox(target.checked)} />} label={<>บันทึกผู้ใช้งานนี้</>} />
                      <Button
                        style={{
                          fontSize: '16px'
                        }}
                        onClick={() => {
                          setOpen(true)
                        }}>
                        ลืมรหัสผ่าน
                      </Button>
                      <Modal
                        open={open}
                        onClose={() => {
                          setOpen(false)
                        }}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                      >
                        <div className="container">
                          <div className="row">
                            <div className="col">
                              <Box
                                sx={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  bgcolor: 'background.paper',
                                  // border: '2px solid none'
                                  borderRadius: '16px',
                                  boxShadow: 24,
                                  width: "99%",
                                  maxWidth: "500px",
                                  p: 4,
                                }}>
                                <div className="row">
                                  <div className="col-12 text-center text-md-start">
                                    <h2 id="parent-modal-title">รีเซ็ตรหัสผ่าน</h2>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-12 text-center text-md-start">
                                    <p id="parent-modal-description">
                                      ท่านจะเลือกรีเซ็ตรหัสผ่านด้วยวิธีใด
                                    </p>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-12 col-md-4 text-center mt-2">
                                    <ResetPasswordByEmail />
                                  </div>
                                  <div className="col-12 col-md-4 text-center mt-2">
                                    <ResetPasswordByOTP />
                                  </div>
                                  <div className="col-12 col-md-4 text-center mt-2">
                                    <Button
                                      variant="outlined"
                                      sx={{
                                        marginLeft: '10px',
                                        borderRadius: '6px',
                                        width: '90px',
                                        height: '36px',
                                        marginRight: '10px',
                                        color: !!style.secondary_color ? `${fontColor(style.secondary_color)}` : 'rgb(5, 48, 117)',
                                        borderColor: !!style.secondary_color ? `${style.secondary_color}` : 'rgb(5, 48, 117)'
                                      }}
                                      onClick={() => {
                                        setOpen(false)
                                      }}
                                    >
                                      ยกเลิก
                                    </Button>
                                  </div>
                                </div>
                              </Box>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    <div className="col-12 text-center" style={{ marginTop: '10px' }}>
                      <Button
                        variant="outlined"
                        sx={{
                          borderRadius: '6px',
                          width: '125px',
                          height: '36px',
                          marginRight: '10px',
                          color: style.secondary_color ?? '#053075',
                          borderColor: style.secondary_color ?? '#053075'
                        }}
                        onClick={() => {
                          handleClose()
                          setUsername('')
                          setPassword('')
                          setLoginFeedback({
                            message: '',
                            color: ''
                          })
                        }}
                        onMouseOver={(e) => {
                          e.target.style.borderColor = style.secondary_color
                        }}
                      >
                        <span>ยกเลิก</span>
                      </Button>
                      {loading ? <LoadingComponent /> :
                        <Button
                          disabled={username.length === 0 || password.length === 0 || !acceptPrivacy}
                          variant="contained"
                          sx={{ color: fontColor(style.secondary_color) ?? '#053075', background: style.secondary_color, borderRadius: '6px', width: '125px', height: '36px' }}
                          onClick={() => {
                            login()
                          }}
                          onMouseOver={(e) => { e.target.style.backgroundColor = style.secondary_color }}
                        >
                          <span>เข้าสู่ระบบ</span>
                        </Button>
                      }
                    </div>
                  </div>
                </Menu>
                {/* </FadeIn> */}
              </body>
            ),
            "policy": (
              <FadeIn>
                <TermAndCondition
                  tempCookie={tempCookie}
                  accept={() => {
                    acceptPolicy()
                  }}
                  deny={() => {
                    setStep('guest')
                    setTempCookie({})
                    setAnchorEl(null);
                    setUsername('')
                    setPassword('')
                    setLoginFeedback('')
                    setCheckbox(false)
                    setShowPassword(false)
                  }}
                />
              </FadeIn>
            ),
            "verify_email": (
              <FadeIn>
                <SendMail
                  sent={() => {
                    setStep('sent_email')
                  }}
                />
              </FadeIn>
            ),
            "sent_email": (
              <FadeIn>
                <SendMailSuccess
                  result={(result) => {
                    if (result) {
                      checkCondition()
                      setCookie('new_user', {
                        changed_password: cookie.new_user.changed_password,
                        requestCA: cookie.new_user.requestCA,
                      }, { path: '/', expires: new Date(Date.now() + 3600000) })
                      navigate(`/${params.prefix}/login-user/verify-success`)
                    }
                  }}
                />
              </FadeIn>
            ),
            "changed_password": (
              <FadeIn>
                <ChangePassword />
              </FadeIn>
            ),
            "popup_consent": (
              <FadeIn>
                <VerifyDetail />
              </FadeIn>
            )
          }[step]
        }

      </>
    : 
    <LoadingComponent />
    
  )
}

export default Login_User;
